

<template>
<div>
<v-container>
<v-row>
<v-col cols="12" sm="12" lg="12">
   <categoria></categoria>
</v-col>
</v-row>   
</v-container>
   
</div>
</template>

<script>

import categoria from '@/components/tienda/categoria/Categoria.vue';



export default {
    data () {
    return {
              
    }
  },
  components: {
    
    categoria
    
  },

  methods: {

}

}
    

</script>


